export function getMimeType(filePath: string): string {
  const extension = filePath.split('.').pop()?.toLowerCase();
  
  const mimeTypes: { [key: string]: string } = {
    // HTML
    'html': 'text/html',
    'htm': 'text/html',
    
    // CSS
    'css': 'text/css',
    
    // JavaScript
    'js': 'application/javascript',
    'mjs': 'application/javascript',
    
    // Images
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'webp': 'image/webp',
    'svg': 'image/svg+xml',
    'ico': 'image/x-icon',
    
    // Documents
    'pdf': 'application/pdf',
    'json': 'application/json',
    'xml': 'application/xml',
    'yaml': 'application/x-yaml',
    'yml': 'application/x-yaml',
    
    // Text
    'txt': 'text/plain',
    'md': 'text/markdown',
    
    // Archives
    'zip': 'application/zip',
    'tar': 'application/x-tar',
    'gz': 'application/gzip'
  };
  
  return mimeTypes[extension || ''] || 'application/octet-stream';
} 